import { useContext, useState } from "react";
import UiContext from "../../../store/ui-context";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import { format } from "date-fns";

const defaultTake = 10;

export const useAPIGetServiceKendaraan = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();

  const [filterValue, setFilterValue] = useState({
    mode: "By Tanggal",
    tanggal: new Date(),
    tanggal_sampai: new Date(),
    tanggal_dari: new Date(),
    kendaraan_id: null,
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });

  const [pagingNotVerify, setPagingNotVerify] = useState({
    page: 1,
    take: 1000,
    total: 0,
    filter: "",
  });

  const [listData, setListData] = useState([]);
  const [listDataNotVerify, setListDataNotVerify] = useState([]);

  //  API call section

  const fetchListData = async ({ page, take, filter }) => {
    const newFilter = filter ?? getFilter(filterValue);

    // Verified list
    requestGet({
      fullUrl: `/api/transaksi/historyservice/data`,
      params: {
        page,
        take,
        filter: newFilter + `;verif_admin_datetime:!=:Null`,
        order: "tanggal_transaksi",
        order_method: "desc",
        with_kendaraan: 1,
        "with_history_service_detils,data_service": 1,
        with_verif_admin: 1,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: newFilter + `;verif_admin_datetime:!=:Null`,
        });
        const newData = data.map((el, index) => ({
          ...el,
          no: (page - 1) * take + index + 1,
        }));
        setListData(newData);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });

    // Not Verified list
    requestGet({
      fullUrl: `/api/transaksi/historyservice/data`,
      params: {
        page: 1,
        take: 10000,
        filter: `verif_admin_datetime:=:Null`,
        order: "tanggal_transaksi",
        order_method: "desc",
        with_kendaraan: 1,
        "with_history_service_detils,data_service": 1,
        with_verif_admin: 1,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPagingNotVerify({
          ...pagingNotVerify,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: `verif_admin_datetime:=:Null`,
        });
        const newData = data.map((el, index) => ({
          ...el,
          no: index + 1,
        }));
        setListDataNotVerify(newData);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // other function section

  const getFilter = (_filterValue) => {
    const filterArr = [];

    const newFilterValue = _filterValue ?? filterValue;

    switch (newFilterValue.mode) {
      case "By Tanggal":
        if (newFilterValue.tanggal) {
          filterArr.push(
            `tanggal_transaksi:>=:${format(
              newFilterValue.tanggal,
              "yyyy-MM-dd"
            )} 00:00:00`
          );
          filterArr.push(
            `tanggal_transaksi:<=:${format(
              newFilterValue.tanggal,
              "yyyy-MM-dd"
            )} 23:59:59`
          );
        }
        break;
      case "By Kendaraan":
        if (newFilterValue.tanggal_dari) {
          filterArr.push(
            `tanggal_transaksi:>=:${format(
              newFilterValue.tanggal_dari,
              "yyyy-MM-dd"
            )} 00:00:00`
          );
        }

        if (newFilterValue.tanggal_sampai) {
          filterArr.push(
            `tanggal_transaksi:<=:${format(
              newFilterValue.tanggal_sampai,
              "yyyy-MM-dd"
            )} 23:59:59`
          );
        }

        if (newFilterValue.kendaraan_id) {
          filterArr.push(`kendaraan_id:=:${newFilterValue.kendaraan_id}`);
        }
        break;
    }

    return filterArr.join(";");
  };

  // handle ui event section

  const handleOnClickRefresh = async () => {
    fetchListData({ page: 1, take: defaultTake });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnUpdateViewRow = (row) => {
    let foundInList = false;
    let newListData = listDataNotVerify.map((el) => {
      if (el.id === row.id) {
        foundInList = true;
        return row;
      }
      return el;
    });

    if (!foundInList) {
      if (newListData.length > 0) {
        newListData.unshift(row);
      } else {
        newListData.push(row);
      }
    }

    // reorder no
    newListData = newListData.map((el, index) => {
      return {
        ...el,
        no: (pagingNotVerify.page - 1) * pagingNotVerify.take + index + 1,
      };
    });

    setListDataNotVerify(newListData);
  };

  const handleOnDeleteViewRow = (row) => {
    let newListData = [...listDataNotVerify];

    const index = newListData.findIndex((el) => el.id === row.id);
    if (index > -1) {
      newListData.splice(index, 1);
    }

    // reorder no
    newListData = newListData.map((el, index) => {
      return {
        ...el,
        no: (pagingNotVerify.page - 1) * pagingNotVerify.take + index + 1,
      };
    });

    setListDataNotVerify(newListData);
  };

  return {
    loading,
    listData,
    listDataNotVerify,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
  };
};
